import { Injectable } from '@angular/core';
import { HTTP_INTERCEPTORS, HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../error-handler/error-handler.service';
import { NotifyService } from '../service/notify.service';


@Injectable()
export class HTTPStatus {
    private requestInFlight: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor() { }

    setHttpStatus(inFlight: boolean) {
        this.requestInFlight.next(inFlight);
    }

    getHttpStatus(): Observable<boolean> {
        return this.requestInFlight.asObservable();
    }
}

@Injectable()
export class APIInterceptor implements HttpInterceptor {

    constructor(private status: HTTPStatus, private errorHandlerService: ErrorHandlerService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.status.setHttpStatus(true);

        return next.handle(this.handlerRequest(request))
            .pipe(
                map((event: any) => {
                    if (event instanceof HttpResponse) {
                        if (event.body && event.body.hasOwnProperty('message') && event.body.hasOwnProperty('localizedMessage') && event.body.hasOwnProperty('className') && event.body.hasOwnProperty('simpleClassName')) {
                            this.errorHandlerService.error = event.body;
                            return this.errorHandlerService.execute();
                        }
                    }

                    return event;
                }),
                catchError(error => {
                    this.errorHandlerService.error = error;
                    //this.errorHandlerService.executeInternalServerError();
                    return throwError(error);
                }),
                finalize(() => {
                    this.status.setHttpStatus(false);
                })
            );
    }

    private handlerRequest(request: HttpRequest<any>) {
        return request.clone({
            url: request.url,
            headers: request.headers
            .set('Authorization', 'Bearer ' + environment.token)
            .set('Cache-Control', 'no-store, no-cache')
            .set('Pragma', 'no-cache')
            .set('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
        });
    }
}

/** Http interceptor providers in outside-in order */
export const httpApiInterceptorProviders = [
    { provide: HTTP_INTERCEPTORS, useClass: APIInterceptor, multi: true },
];
